export type EMAIL_ADDRESS = (value: string) => string | undefined
export type PROFESSIONAL_EMAIL_ADDRESS = (value: string) => string | undefined

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const PERSONAL_EMAIL_SUFFIXES = [
  'gmail.com',
  'hotmail.com',
  'yahoo.com',
  'outlook.com',
  'live.com',
  'icloud.com',
  'me.com',
  'msn.com',
  'aol.com',
  'wanadoo.fr',
  'orange.fr',
  'yopmail.com',
  'free.fr',
  'hotmail.fr',
  'protonmail.com',
  'proton.me',
]

export const mustBeEmailAddress: EMAIL_ADDRESS = value =>
  EMAIL_REGEX.test(value) ? undefined : 'EMAIL_ADDRESS'

export const mustBeBlankOrEmailAddress: EMAIL_ADDRESS = value =>
  value === '' || EMAIL_REGEX.test(value) ? undefined : 'EMAIL_ADDRESS'

export const mustBeProfessionnalEmailAddress: PROFESSIONAL_EMAIL_ADDRESS =
  value =>
    EMAIL_REGEX.test(value) &&
    !PERSONAL_EMAIL_SUFFIXES.includes(value.split('@')[1])
      ? undefined
      : 'PROFESSIONAL_EMAIL_ADDRESS'
